import { NgModule }           from '@angular/core';
import { FormsModule }        from '@angular/forms';
import { CommonModule }       from '@angular/common';
import { UserComponent }      from './user.component';
import { DriverComponent }    from './driver.component';
import { CompanyComponent }   from './company.component';
import { CarComponent }       from './car.component';
import { CommonToolModule }   from '../common/common-tool.module';
import { MemberRegistComponent } from './member-regist.component';
import { EqualsValidator } from '../common/equals-validator.directive';
import { NgxMyDatePickerModule }  from 'ngx-mydatepicker';

@NgModule({
  imports: [
    CommonModule,  //各sub moduleに追加する必要あり
    FormsModule,   //各sub moduleに追加する必要あり
    CommonToolModule,    //共通部品をcomponentとしてimportするとエラーになる、module化してimportする
    NgxMyDatePickerModule
  ],
  declarations: [
    UserComponent,
    DriverComponent,
    CompanyComponent,
    CarComponent,
    MemberRegistComponent,
    EqualsValidator
  ],
  providers: [ ]
})
export class MemberModule {}



// WEBPACK FOOTER //
// ./src/app/member-kanri/member.module.ts